import { queryOptions, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from 'bff/ApiClientProvider';
import type { AnnuityDetailsViewModel, IssuedProductGetAnnuityDetailsRequest } from 'bff/client';

export const annuityDetailsKeys = {
  base: () => ['annuity-details'] as const
};

export const useInvalidateAnnuityDetails = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({
      queryKey: [annuityDetailsKeys],
      refetchType: 'all'
    });
};

export const getAnnuityDetails = (request: IssuedProductGetAnnuityDetailsRequest) => {
  const { issuedProductApi } = useApiClient();

  return queryOptions({
    queryKey: annuityDetailsKeys.base(),
    queryFn: async () => issuedProductApi.issuedProductGetAnnuityDetails(request),
    select: (response): AnnuityDetailsViewModel | undefined => response?.data
  });
};
